import React, { useEffect, useRef, useState } from 'react';
import { Box, Grid } from '@mui/material';
import RoundButton from './roundButton';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { useReactToPrint } from 'react-to-print';
import MemberSummaryComponent from './memberSummaryComponent';
import { currentSegmentSeriesGroup } from '../../services/cadService';

import { getMembersFromRootMemberSummary } from '../../services/summaryService';
import { uniqueCodeTemplate } from '../../services/bomService';
import {
  allSegments,
  getPartNumbers,
  getMembersFromStepForStackables,
  getMembersFromMembers,
  getPartNumberString,
  getNormalSteps
} from '../../services/tactonService';
import PartNumberComponent from './partNumberComponent';

const ExcelJS = require('exceljs');
function SummaryComponents(props) {
  let printRef = useRef();

  const {
    isModal,
    handleClose,
    contactus,
    dataItems,
    sessionDataItems,
    displayPartNumber,
    orderSummarySteps,
    uniquePartIdentifier
  } = props;

  const [stackableSteps, setStackableSteps] = useState([]);

  const printSummary = useReactToPrint({
    content: () => printRef.current,
    removeAfterPrint: true,
    copyStyles: true
  });

  useEffect(() => {
    if (!isModal) printSummary();
  }, []);

  useEffect(async () => {
    if (!dataItems.isNormalProduct) {
      var selectionData = await getMembersFromStepForStackables(
        dataItems,
        sessionDataItems
      );
      setStackableSteps(selectionData[1]);
    }
  }, []);
  //To get segment display members
  const currentWorkstationMembers = segment => {
    var seriesUIGroup = currentSegmentSeriesGroup(segment);
    if (seriesUIGroup.length == 0) {
      //if H3 Transition use selection members in the summary
      //get the current segment group index
      var currentSegmentRootGroupIndex =
        dataItems.segmentStep.rootGroup.members.findIndex(x =>
          x.name.includes(segment.name)
        );
      //get selection group from prev segment group
      var prevSegmentRootGroup =
        dataItems.segmentStep.rootGroup.members[
          currentSegmentRootGroupIndex - 1
        ];
      return prevSegmentRootGroup.members.filter(x =>
        x.name.includes('selection')
      );
      ///return selectionMemberGroup[0].members.filter(x => !x.name.includes("add_segment"));
    }
    return seriesUIGroup;
  };

  const endSegment = () => {
    var allStations = allSegments(dataItems);
    var lastSegmentSelectionGroup = allStations[
      allStations.length - 1
    ].members.filter(x => x.name.includes('selection'));
    return lastSegmentSelectionGroup[0].members.filter(
      x => !x.name.includes('add_segment')
    );
  };

  const getBOMMembers = isAggregate => {
    var orderSummaryMembers = [];
    var members = [];
    var sequence = 0;
    var orderSummaryStep = orderSummarySteps.find(
      x => x.available == true && x.name.includes('order_summary')
    );
    if (!orderSummaryStep.hasOwnProperty('rootGroup')) return;
    var filterMembers = orderSummaryStep.rootGroup.members.filter(x =>
      x.name.includes('summary_group')
    );
    if (isAggregate) {
      var unassembledParts = orderSummaryStep.rootGroup.members.filter(x =>
        x.name.includes('unassembled_summary')
      );
      if (filterMembers.length > 0 && unassembledParts.length > 0)
        filterMembers[0] = unassembledParts[0];
    }
    for (let member of filterMembers) {
      orderSummaryMembers = orderSummaryMembers.concat(
        getMembersFromRootMemberSummary(member)
      );
    }

    for (let summarymember of orderSummaryMembers) {
      sequence = sequence + 1;
      summarymember.imageSequence = sequence;
      summarymember.quantity = 1;
      members.push(summarymember);
    }
    return members;
  };

  const orderSummaryStep = () => {
    var allStations = orderSummarySteps.filter(
      x => x.available == true && x.name.includes('order_summary')
    );
    return allStations[0];
  };

  const aggregateBomSummaryStep = () => {
    var orderSummaryStep = orderSummarySteps.find(
      x => x.available == true && x.name.includes('order_summary')
    );
    var aggregateBOMInfoMembers = orderSummaryStep.rootGroup.members.filter(x =>
      x.name.includes('bom_summary_info')
    );
    return aggregateBOMInfoMembers[0];
  };

  const getAggregateBOMInfoMembers = () => {
    var orderSummaryStep = orderSummarySteps.find(
      x => x.available == true && x.name.includes('order_summary')
    );
    var aggregateBOMInfoMembers = orderSummaryStep.rootGroup.members.filter(x =>
      x.name.includes('bom_summary_info')
    );
    return aggregateBOMInfoMembers;
  };

  const getAggregateBOMMembers = () => {
    var aggregateBOMMembers = [];
    var sequence = 0;
    var orderSummaryMembers = getBOMMembers(true);

    if (orderSummaryMembers == undefined || orderSummaryMembers.length <= 0)
      return;
    for (let summarymember of orderSummaryMembers) {
      var aggregateBOMMember = {
        name: '',
        description: '',
        value: '',
        valueDescription: '',
        quantity: 0,
        imageSequence: 0
      };
      aggregateBOMMember = aggregateBOMMembers.find(
        x =>
          x.description == summarymember.description &&
          x.value == summarymember.value
      );
      if (aggregateBOMMember) {
        aggregateBOMMember.quantity = aggregateBOMMember.quantity + 1;
      } else {
        aggregateBOMMember = {
          name: '',
          description: '',
          value: '',
          valueDescription: '',
          quantity: 0,
          imageSequence: 0
        };
        sequence = sequence + 1;
        aggregateBOMMember.name = summarymember.name;
        aggregateBOMMember.description = summarymember.description;
        aggregateBOMMember.value = summarymember.value;
        aggregateBOMMember.valueDescription = summarymember.valueDescription;
        aggregateBOMMember.quantity = 1;
        aggregateBOMMember.imageSequence = sequence;
        aggregateBOMMembers.push(aggregateBOMMember);
      }
    }
    //this.isPrinting = false;
    return aggregateBOMMembers;
  };

  const getMembers = step => {
    var filterMembers = [];
    if (step?.name?.includes('summary_group')) {
      filterMembers = step.rootGroup?.members.filter(x =>
        x.name.includes('summary_group')
      );
    } else if (
      step?.name?.includes('accessories_step') ||
      step?.name?.includes('sealkit_step')
    )
      filterMembers = step.rootGroup?.members.filter(
        x => x.properties && x.properties['info_group'] == 'yes'
      );
    else {
      filterMembers = step.rootGroup?.members.filter(x =>
        x.name.includes('ui_group')
      );
    }
    if (filterMembers.length == 0) {
      var infoGroup = step.rootGroup?.members.filter(
        x => x.properties && x.properties['info_group'] == 'yes'
      );
      filterMembers = step.rootGroup?.members.filter(
        x => !infoGroup.includes(x)
      );
    }
    return filterMembers;
  };

  const isUniqueCodeAvailable = () => {
    var uniqueCode = uniqueCodeTemplate(dataItems);
    if (uniqueCode == '') return false;
    else return true;
  };

  const getManifoldPartNumber = step => {
    if (dataItems?.isManifoldProduct && step.name.includes('manifold')) {
      var orderSummaryStep = orderSummarySteps.find(
        x => x.available == true && x.name.includes('order_summary')
      );

      var orderCodeInfoGroup = orderSummaryStep.rootGroup.members.filter(x =>
        x.name.includes('summary_group')
      );
      var orderSummaryMembers = getMembersFromRootMemberSummary(
        orderCodeInfoGroup[0]
      );
      return orderSummaryMembers;
    }
  };

  const ifModelInfo = () => {
    try {
      var orderSummaryStep = orderSummarySteps.find(
        x => x.available == true && x.name.includes('order_summary')
      );
      if (!orderSummaryStep.hasOwnProperty('rootGroup')) return;
      var filterMembers = orderSummaryStep.rootGroup.members.filter(x =>
        x.name.includes('model_number_info')
      );
      if (filterMembers.length > 0) return true;
      else return false;
    } catch (error) {
      console.log(error);
      return false;
    }
  };

  const getModelInfoMembers = () => {
    var orderSummaryStep = orderSummarySteps.find(
      x => x.available == true && x.name.includes('order_summary')
    );
    var modelNumInfoMembers = orderSummaryStep.rootGroup.members.filter(x =>
      x.name.includes('model_number_info')
    );
    return modelNumInfoMembers;
  };

  const ifAssemblyEndAvailable = () => {
    var allStations = allSegments(dataItems);
    var lastSegmentSelectionGroup = allStations[
      allStations.length - 1
    ].members.filter(x => x.name.includes('selection'));
    var assemblyEndMembers = lastSegmentSelectionGroup[0].members.filter(
      x =>
        !x.name.includes('add_segment') &&
        x.properties &&
        x.properties.hidden != 'yes'
    );
    if (assemblyEndMembers.length > 0) return true;
    else return false;
  };

  const showBOMSummary = () => {
    var orderSummaryStep = orderSummarySteps.filter(
      x => x.available == true && x.name.includes('order_summary')
    );
    if (orderSummaryStep.length == 0) return false;
    if (!orderSummaryStep[0].hasOwnProperty('rootGroup')) return;
    var filterMembers = orderSummaryStep[0].rootGroup.members.filter(x =>
      x.name.includes('bom_summary_info')
    );
    if (filterMembers.length > 0) {
      var bom_summary_info_group = filterMembers.filter(
        x =>
          x.properties !== undefined &&
          x.properties['ph_show_bom_summary'] == 'yes'
      );
      if (bom_summary_info_group.length > 0) return true;
      else return false;
    } else return false;
  };

  const ifBOMInfoSummary = () => {
    var orderSummaryStep = orderSummarySteps.filter(
      x => x.available == true && x.name.includes('order_summary')
    );
    if (orderSummaryStep.length == 0) return false;
    if (!orderSummaryStep[0].hasOwnProperty('rootGroup')) return;
    var filterMembers = orderSummaryStep[0].rootGroup.members.filter(x =>
      x.name.includes('bom_summary_info')
    );
    if (filterMembers.length > 0) return true;
    else return false;
  };

  const getStackablesMembers = step => {
    return step.values;
  };

  const getPartNumber = step => {
    var parts = getPartNumbers(step);
    return parts[0].value;
  };

  const stepMembers = step => {
    return getMembers(step);
  };

  const manifoldTab = () => {
    return dataItems.manifoldStep.description;
  };

  const getPartNumberForExcel = () => {
    if (dataItems.isNormalProduct || dataItems.isManifoldProduct)
      return getPartNumberString(dataItems);
    else return dataItems?.infoGroup?.orderCodeComplete?.value;
  };

  const fileDownload = () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Summary');

    const columns = [
      { width: 40 },
      { width: 40 },
      { width: 40 },
      { width: 40 }
    ];

    worksheet.columns = columns;

    let contactInfo = contactus;
    let productName = sessionDataItems.seriesName;
    let title = contactInfo.title || '';
    let name = contactInfo.name || '';
    let email = contactInfo.email || '';
    let address1 = contactInfo.address1 || '';
    let phone = contactInfo.phone ? 'Ph: ' + contactInfo.phone : '';
    let cityaddress = contactInfo.cityaddress || '';
    let fax = contactInfo.fax ? 'Fax: ' + contactInfo.fax : '';
    let country = contactInfo.country || '';

    worksheet.getRow(1).getCell(1).value = title;
    worksheet.getRow(1).getCell(2).value = name;
    worksheet.getRow(1).getCell(3).value = email;
    worksheet.getRow(1).getCell(4).value = '';

    worksheet.getRow(2).getCell(1).value = '';
    worksheet.getRow(2).getCell(2).value = address1;
    worksheet.getRow(2).getCell(3).value = phone;
    worksheet.getRow(2).getCell(4).value = '';

    worksheet.getRow(3).getCell(1).value = '';
    worksheet.getRow(3).getCell(2).value = cityaddress;
    worksheet.getRow(3).getCell(3).value = fax;
    worksheet.getRow(3).getCell(4).value = '';

    worksheet.getRow(4).getCell(1).value = '';
    worksheet.getRow(4).getCell(2).value = '';
    worksheet.getRow(4).getCell(3).value = country;
    worksheet.getRow(4).getCell(4).value = '';
    worksheet.addRow({});
    worksheet.addRow([productName]);
    handleRowColor(worksheet, worksheet.lastRow.number, 14);
    worksheet.addRow({});
    worksheet.addRow([props.lang?.CONFIGURATION_CODE]);
    handleRowColor(worksheet, worksheet.lastRow.number, 12);

    if (dataItems.isManifoldProduct) {
      worksheet.addRow(['Part Number', uniquePartIdentifier]);
      worksheet.addRow(['Assembled Components', getPartNumberForExcel()]);
    } else {
      worksheet.addRow([getPartNumberForExcel()]);
    }

    worksheet.addRow({});

    if (dataItems.isManifoldProduct) {
      if (ifModelInfo) {
        getModelInfoMembers().map((member, j) => {
          addMembersToExcel(member, false, false, true, worksheet);
          worksheet.addRow({});
        });
      }
      worksheet.addRow([manifoldTab()]);
      handleRowColor(worksheet, worksheet.lastRow.number, 12);
      handleRowBottomBorder(worksheet, worksheet.lastRow.number);
      getMembers(dataItems.manifoldStep).map(member => {
        addMembersToExcel(member, true, false, false, worksheet);
      });

      allSegments(dataItems).map(workstation => {
        worksheet.addRow({});
        worksheet.addRow([workstation.description]);
        handleRowColor(worksheet, worksheet.lastRow.number, 12);
        handleRowBottomBorder(worksheet, worksheet.lastRow.number);
        currentWorkstationMembers(workstation).map(member => {
          addMembersToExcel(member, true, false, false, worksheet);
        });
      });
      worksheet.addRow({});
      if (ifAssemblyEndAvailable()) {
        handleRowBottomBorder(worksheet, worksheet.lastRow.number);
        endSegment()?.map(member => {
          addMembersToExcel(member, false, false, false, worksheet);
        });
        worksheet.addRow({});
      }

      if (showBOMSummary()) {
        worksheet.addRow([orderSummaryStep().description]);
        handleRowColor(worksheet, worksheet.lastRow.number, 12);
        handleRowBottomBorder(worksheet, worksheet.lastRow.number);
        worksheet.addRow([
          'Sequence #',
          'Quantity',
          'PartNumber',
          'Description'
        ]);
        getBOMMembers().forEach(member => {
          addMembersToExcel(member, false, true, false, worksheet);
        });
        worksheet.addRow({});
      }

      if (ifBOMInfoSummary()) {
        worksheet.addRow([aggregateBomSummaryStep().description]);
        handleRowColor(worksheet, worksheet.lastRow.number, 12);
        handleRowBottomBorder(worksheet, worksheet.lastRow.number);
        getAggregateBOMInfoMembers().map(member => {
          addMembersToExcel(member, false, false, true, worksheet);
        });
        worksheet.addRow({});
      }

      if (showBOMSummary()) {
        worksheet.addRow([
          'Sequence #',
          'Quantity',
          'PartNumber',
          'Description'
        ]);
        getAggregateBOMMembers().forEach(member => {
          addMembersToExcel(member, false, true, false, worksheet);
        });
      }
    } else if (dataItems.isNormalProduct) {
      if (isPTO()) {
        worksheet.addRow([productSelectionTab()]);
        handleRowColor(worksheet, worksheet.lastRow.number, 12);
        handleRowBottomBorder(worksheet, worksheet.lastRow.number);
        getProductSelectionMembers().map(member => {
          addMembersToExcel(member, false, false, false, worksheet);
        });
        worksheet.addRow({});
      }

      getNormalSteps(dataItems).map((step, index) => {
        worksheet.addRow([step.description]);
        handleRowColor(worksheet, worksheet.lastRow.number, 12);
        handleRowBottomBorder(worksheet, worksheet.lastRow.number);

        if (index == 0) {
          worksheet.addRow(['Part Number', getPartNumber(step)]);
        }

        stepMembers(step).map((member, j) => {
          addMembersToExcel(member, false, false, false, worksheet);
        });
      });
    } else {
      stackableSteps?.map((step, index) => {
        worksheet.addRow([step.description]);
        handleRowColor(worksheet, worksheet.lastRow.number, 12);
        handleRowBottomBorder(worksheet, worksheet.lastRow.number);

        getStackablesMembers(step)?.map((member, j) => {
          addMembersToExcel(member, false, false, false, worksheet);
        });

        worksheet.addRow({});
      });
    }

    handleRowAlignment(worksheet);
    let cadPartNumber;
    if (dataItems.isManifoldProduct) cadPartNumber = uniquePartIdentifier;
    else cadPartNumber = dataItems.infoGroup.cadCode.value;

    workbook.xlsx.writeBuffer().then(data => {
      const blob = new Blob([data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheet.sheet'
      });

      const url = window.URL.createObjectURL(blob);
      const anchor = document.createElement('a');
      anchor.href = url;
      anchor.download = cadPartNumber + '_summary.xlsx';
      anchor.click();
      window.URL.revokeObjectURL(url);
    });
  };

  const addMembersToExcel = (
    member,
    showGroupHeader,
    isBOMSummary,
    isBOMInfo,
    worksheet
  ) => {
    if (!isHidden(member)) {
      if (!isGroup(member)) {
        if (isBOMInfo) {
          worksheet.addRow([getValue(member)]);
        } else {
          if (isBOMSummary) {
            worksheet.addRow([
              member.imageSequence,
              member.quantity,
              getValue(member),
              nameTranslation(member)
            ]);
          } else {
            worksheet.addRow([nameTranslation(member), getValue(member)]);
          }
        }
      } else if (isDisplayGroup(member, showGroupHeader)) {
        worksheet.addRow([getGroupName(member)]);
      }

      children(member).forEach((child, index) => {
        addMembersToExcel(
          child,
          showGroupHeader,
          isBOMSummary,
          isBOMInfo,
          worksheet
        );
      });
    }
  };

  const nameTranslation = member => {
    return member.description;
  };

  const getValue = member => {
    return member.valueDescription;
  };

  const showHeader = (member, showGroupHeader) => {
    return this.isGroup(member) && showGroupHeader && this.hasChildren(member);
  };

  const isHidden = member => {
    if (!member.properties) return false;
    if (member.properties.hidden == 'yes') return true;

    if (member.description == 'Section Position') return true;

    return false;
  };

  const children = member => {
    if (!member.isGroup) return [];
    return member.members.filter(x => !x.name.includes('add_segment'));
  };

  const hasChildren = member => {
    var children = getMembersFromMembers(member).filter(
      x =>
        !x.isGroup &&
        x.properties.hidden != 'yes' &&
        x.properties.guitype != GuiTypes.ReadOnly
    );
    return children.length > 0;
  };

  const isGroup = member => {
    return member.isGroup;
  };

  const getGroupName = member => {
    return member.description;
  };

  const isDisplayGroup = (member, showGroupHeader) => {
    return (
      member.properties &&
      member.properties.ph_show_group_heading == 'yes' &&
      !showGroupHeader
    );
  };

  const handleRowColor = (worksheet, rowNumber, size) => {
    worksheet.getRow(rowNumber).eachCell(cell => {
      cell.font = {
        color: { argb: '000000' },
        size: size,
        bold: true
      };
    });
  };

  const handleRowBottomBorder = (worksheet, rowNumber) => {
    worksheet.getRow(rowNumber).getCell(1).border = {
      bottom: { style: 'thick', color: { argb: 'ffb91d' } }
    };
  };

  const handleRowAlignment = worksheet => {
    worksheet.eachRow(function (Row, rowNum) {
      Row.eachCell(function (Cell, cellNum) {
        Cell.alignment = {
          horizontal: 'left'
        };
      });
    });
  };

  const isContactInfoVisible = () => {
    return sessionDataItems.contentSyndication == null;
  };

  const isPTO = () => {
    let normalSummarySteps = dataItems.tactonModel.steps;
    if (
      normalSummarySteps[0].name == 'product_selection' &&
      normalSummarySteps[0].description.includes('PTO')
    )
      return true;
    else return false;
  };

  const productSelectionStep = () => {
    var steps = dataItems.tactonModel.steps.filter(x =>
      x.name.includes('product_selection')
    );
    return steps[0];
  };
  const productSelectionTab = () => {
    return productSelectionStep().description;
  };

  const getProductSelectionMembers = () => {
    var filterMembers = productSelectionStep().rootGroup.members;
    return filterMembers;
  };

  return (
    <Box className={isModal ? 'modal-common summary-modal' : ''}>
      <Grid container className="summary-wrapper">
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          onClick={handleClose}
          className="align-right"
        >
          <CloseRoundedIcon />
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12} ref={printRef}>
          {isContactInfoVisible() && (
            <Grid container className="summary-row font-size-12">
              <Grid item xs={12} sm={3}>
                <img
                  src="https://www.parker.com/content/dam/Parker-com/parkerlogo.png"
                  className="parker-logo"
                />
              </Grid>
              <Grid item xs={12} sm={3} className="summary-title">
                <Grid>{contactus?.title}</Grid>
              </Grid>
              <Grid item xs={12} sm={3}>
                <Grid>{contactus?.name}</Grid>
                <Grid>{contactus?.address1}</Grid>
                <Grid>{contactus?.cityaddress}</Grid>
                <Grid>{contactus?.country}</Grid>
              </Grid>
              <Grid item xs={12} sm={3}>
                <Grid>{contactus.email}</Grid>
                <Grid>Ph: {contactus?.phone}</Grid>
                <Grid> Fax: {contactus?.fax}</Grid>
              </Grid>
            </Grid>
          )}
          <Grid container className="summary-row">
            <Grid
              item
              xs={12}
              sm={8}
              md={8}
              sx={{
                whiteSpace: 'pre-wrap',
                overflowWrap: 'break-word',
                wordBreak: 'break-word',
                fontSize: '27px !important'
              }}
            >
              {sessionDataItems?.seriesName}
            </Grid>
            <Grid item xs={12} sm={12} md={2} className="print-summary">
              <RoundButton
                name={props.lang?.PRINT}
                classname={'hidden-print margin-0 floatR yellow-button'}
                onClick={printSummary}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={2}>
              <RoundButton
                name="Export to Excel"
                classname={'hidden-print margin-0 floatR yellow-button'}
                onClick={() => fileDownload()}
              />
            </Grid>
          </Grid>
          <Grid
            container
            className="summary-row"
            sx={{ borderBottom: '2px solid #979797' }}
          >
            <Grid item className="normal-header" xs={12}>
              {props.lang?.CONFIGURATION_CODE}
            </Grid>

            {isUniqueCodeAvailable() && <Grid>{uniquePartIdentifier}</Grid>}

            <Grid item xs={12}>
              <PartNumberComponent startData={dataItems} />
            </Grid>

            {dataItems?.isManifoldProduct ? (
              <Grid container>
                {ifModelInfo() && (
                  <Grid item>
                    {getModelInfoMembers().map((member, j) => (
                      <div key={member.name + '_' + j}>
                        <MemberSummaryComponent
                          member={member}
                          isBomInfo={true}
                          showGroupHeader={false}
                          col={6}
                        />
                      </div>
                    ))}
                  </Grid>
                )}
                {
                  <>
                    <Grid item lg={6} md={6} sm={12} xs={12}>
                      <div className="summary-details-category">
                        {manifoldTab()}
                      </div>
                      {isUniqueCodeAvailable() && (
                        <Grid container>
                          <Grid
                            item
                            lg={6}
                            md={6}
                            sm={12}
                            xs={12}
                            className="normal-header"
                          >
                            Part Number
                          </Grid>
                          <Grid
                            item
                            lg={6}
                            md={6}
                            sm={12}
                            xs={12}
                            className="attribute-value"
                          >
                            {displayPartNumber}
                          </Grid>

                          <Grid item lg={12} md={12} sm={12} xs={12}>
                            {getManifoldPartNumber(dataItems?.manifoldStep).map(
                              (member, j) => (
                                <div key={member.name + '_' + j}>
                                  <MemberSummaryComponent
                                    member={member}
                                    showGroupHeader={true}
                                    col={6}
                                  />
                                </div>
                              )
                            )}
                          </Grid>
                        </Grid>
                      )}
                      <Grid>
                        {getMembers(dataItems?.manifoldStep).map(
                          (member, j) => (
                            <div key={member.name + '_' + j}>
                              <MemberSummaryComponent
                                member={member}
                                showGroupHeader={true}
                                col={6}
                              />
                            </div>
                          )
                        )}
                      </Grid>
                    </Grid>
                    <Grid item lg={6} md={6} sm={0} xs={0}></Grid>
                  </>
                }

                {allSegments(dataItems).map((workstation, i) => {
                  return (
                    <Grid
                      item
                      lg={6}
                      md={6}
                      sm={12}
                      xs={12}
                      key={workstation.name}
                      className="pr-1"
                    >
                      <Grid className="summary-details-category">
                        {workstation.description}
                      </Grid>
                      <Grid>
                        {currentWorkstationMembers(workstation)?.map(
                          (member, j) => (
                            <div key={member.name + '_' + j}>
                              <MemberSummaryComponent
                                member={member}
                                showGroupHeader={true}
                                col={6}
                              />
                            </div>
                          )
                        )}
                      </Grid>
                    </Grid>
                  );
                })}

                {ifAssemblyEndAvailable() && (
                  <Grid item xs={12}>
                    <Grid
                      item
                      className="segment-footer"
                      lg={6}
                      md={6}
                      sm={12}
                      xs={12}
                    >
                      {endSegment()?.map((member, j) => (
                        <div key={member.name + '_' + j}>
                          <MemberSummaryComponent member={member} col={6} />
                        </div>
                      ))}
                    </Grid>
                    <Grid item lg={6} md={6} sm={0} xs={0}></Grid>
                  </Grid>
                )}

                {showBOMSummary() && (
                  <div className="div-bom">
                    <Grid item xs={12} className="summary-details-category">
                      <label>{orderSummaryStep().description}</label>
                    </Grid>
                    <Grid container className="summary-bom-table">
                      <Grid item xs={3} className="attribute-description">
                        Sequence #
                      </Grid>
                      <Grid item xs={3} className="attribute-description">
                        Quantity
                      </Grid>
                      <Grid item xs={3} className="attribute-description">
                        PartNumber
                      </Grid>
                      <Grid item xs={3} className="attribute-description">
                        Description
                      </Grid>
                      <Grid item xs={12}>
                        {getBOMMembers()?.map((member, j) => (
                          <div key={member.name + '_' + j}>
                            <MemberSummaryComponent
                              member={member}
                              quantity={member.quantity}
                              sequence={member.imageSequence}
                              showGroupHeader={false}
                              isBomSummary={true}
                              col={3}
                              isTable={true}
                            />
                          </div>
                        ))}
                      </Grid>
                    </Grid>
                  </div>
                )}

                <div className="div-bom">
                  {ifBOMInfoSummary() && (
                    <>
                      <Grid item xs={12} className="summary-details-category">
                        <label>{aggregateBomSummaryStep().description}</label>
                      </Grid>
                      <Grid item xs={12}>
                        {getAggregateBOMInfoMembers()?.map((member, j) => (
                          <div key={member.name + '_' + j}>
                            <MemberSummaryComponent
                              member={member}
                              isBomInfo={true}
                              showGroupHeader={false}
                              col={12}
                            />
                          </div>
                        ))}
                      </Grid>
                    </>
                  )}
                  {showBOMSummary() && (
                    <Grid container className="summary-bom-table">
                      <Grid item xs={3} className="attribute-description">
                        Sequence #
                      </Grid>
                      <Grid item xs={3} className="attribute-description">
                        Quantity
                      </Grid>
                      <Grid item xs={3} className="attribute-description">
                        PartNumber
                      </Grid>
                      <Grid item xs={3} className="attribute-description">
                        Description
                      </Grid>
                      <Grid item xs={12}>
                        {getAggregateBOMMembers()?.map((member, j) => (
                          <div key={member.name + '_' + j}>
                            <MemberSummaryComponent
                              member={member}
                              quantity={member.quantity}
                              sequence={member.imageSequence}
                              showGroupHeader={false}
                              isBomSummary={true}
                              col={3}
                              isTable={true}
                            />
                          </div>
                        ))}
                      </Grid>
                    </Grid>
                  )}
                </div>
              </Grid>
            ) : dataItems.isNormalProduct ? (
              <>
                {isPTO() && (
                  <Grid container>
                    <Grid item xs={12} className="summary-details-category">
                      {productSelectionTab()}
                    </Grid>

                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      {getProductSelectionMembers().map((member, j) => (
                        <div key={member.name + '_' + j}>
                          <MemberSummaryComponent
                            member={member}
                            showGroupHeader={false}
                            col={6}
                          />
                        </div>
                      ))}
                    </Grid>
                  </Grid>
                )}
                {getNormalSteps(dataItems).map((step, index) => {
                  return (
                    <Grid container key={step.name + '_' + index}>
                      <Grid
                        item
                        lg={12}
                        md={12}
                        sm={12}
                        xs={12}
                        className="summary-details-category"
                      >
                        {step.description}
                      </Grid>
                      {index == 0 && (
                        <>
                          <Grid
                            item
                            lg={6}
                            md={6}
                            sm={12}
                            xs={12}
                            className="attribute-description"
                          >
                            Part Number
                          </Grid>
                          <Grid
                            item
                            lg={6}
                            md={6}
                            sm={12}
                            xs={12}
                            className="attribute-value"
                          >
                            {getPartNumber(step)}
                          </Grid>
                        </>
                      )}

                      {
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          {stepMembers(step).map((member, j) => (
                            <div key={member.name + '_' + j}>
                              <MemberSummaryComponent
                                member={member}
                                showGroupHeader={false}
                                col={6}
                              />
                            </div>
                          ))}
                        </Grid>
                      }
                    </Grid>
                  );
                })}
              </>
            ) : (
              !dataItems.isNormalProduct && (
                <Grid container>
                  {stackableSteps?.map((step, index) => {
                    return (
                      <Grid
                        item
                        lg={index == 0 ? 12 : 6}
                        md={index == 0 ? 12 : 6}
                        sm={12}
                        xs={12}
                        key={step.name}
                        className="pr-1"
                      >
                        <div
                          className={
                            index == 0
                              ? 'summary-details-category width-50'
                              : 'summary-details-category'
                          }
                          key={step.name + '_' + index}
                        >
                          {step.description}
                        </div>
                        {getStackablesMembers(step)?.map((member, j) => (
                          <div key={member.name + '_' + j}>
                            <MemberSummaryComponent
                              member={member}
                              showGroupHeader={!dataItems.isNormalProduct}
                              col={index == 0 ? 3 : 6}
                            />
                          </div>
                        ))}
                      </Grid>
                    );
                  })}
                </Grid>
              )
            )}
          </Grid>
        </Grid>
        {isModal ? (
          <Grid container className="summary-row">
            <Grid item xs={12} sm={2}>
              <RoundButton
                name={props.lang?.CLOSE}
                classname="normal-button"
                onClick={handleClose}
              />
            </Grid>
            <Grid item xs={0} sm={8}></Grid>
            <Grid item xs={12} sm={2}>
              <RoundButton
                classname="floatR yellow-button"
                name={props.lang?.PRINT}
                onClick={printSummary}
              />
            </Grid>
          </Grid>
        ) : (
          <Grid></Grid>
        )}
      </Grid>
    </Box>
  );
}

export default SummaryComponents;
